import React from 'react';
import { Dialog } from '@mui/material';
import UpdateForm from './UpdateForm';

const UpdateModal = ({ open, toggle, data, setData, onUpdate }) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="sm"
      scroll="paper"
      onClose={toggle}
    >
      <UpdateForm data={data} setData={setData} onUpdate={onUpdate} />
    </Dialog>
  );
};

export default UpdateModal;
